var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubmitIcon = function SvgSubmitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2ZM12.2071 15.2071L17.2071 10.2071L15.7928 8.79285L11.5 13.0857L8.70706 10.2928L7.29285 11.7071L10.7928 15.2071C11.1834 15.5976 11.8165 15.5976 12.2071 15.2071Z",
    fill: "white"
  })));
};
export { SvgSubmitIcon as ReactComponent };
export default __webpack_public_path__ + "assets/5a20c91e.svg";